import React from "react";
import { WPTaxTerm } from "../../../../constants/types";
import { useTaxonomies } from "../../../../services/app-state";
import { useAssessmentState } from "../../../../services/assessment-state";
import { AssessmentState } from "../../../../services/assessment-state/types";
import { TextButton, TextButtonGroup } from "../shared/TextButton";

export const SupportRequirements = () => {
    const [{ conditions }] = useTaxonomies();
    const { state, setState } = useAssessmentState();

    const handleConditionClick = (condition: WPTaxTerm) => {
        const { conditions } = state;
        // If exists, remove
        if (conditions.includes(`${condition.id}`)) {
            setState({
                conditions: conditions.filter(c => c != `${condition.id}`),
            });
        }
        // If not, add
        else {
            setState({
                conditions: [...state.conditions, `${condition.id}`],
            });
        }
    };

    const renderPartOne = () => {
        return (
            <div>
                <TextButtonGroup className="selection-container" title="Are you looking for support for a specific disorder or concern? Select any or all that apply">
                    {conditions.map(condition => (
                        <TextButton
                            key={condition.id}
                            onClick={() => {
                                handleConditionClick(condition);
                            }}
                            isActive={state.conditions.includes(`${condition.id}`)}
                        >
                            {condition.name}
                        </TextButton>
                    ))}
                </TextButtonGroup>
            </div>
        );
    };

    return (
        renderPartOne()
    );
};

export const createMeta = (state: AssessmentState) => ({
    title: state.target === "MYSELF" ? "Support for you" : "Support for them",
    canProgress: true,
    canSkip: true,
});
